import { TableConfig, TableType } from "./or-table.type";

export const TABLE_CONFIGS: Record<TableType, TableConfig> = {
  [TableType.ACTIVITY]: {
    type: TableType.ACTIVITY,
    headers: [
      { header: "Origen" },
      { header: "Descripción" },
      { header: "Fecha" },
    ],
  },
  [TableType.CLIENTS]: {
    type: TableType.CLIENTS,
    headers: [
      { header: "Nombre" },
      { header: "Correo electrónico" },
      { header: "Fecha de nacimiento" },
      { header: "Registro" },
      { header: "" },
    ],
  },
  [TableType.ORDERS]: {
    type: TableType.ORDERS,
    headers: [
      { header: "No. de pedido" },
      { header: "Nombre de cliente" },
      { header: "Fecha de compra" },
      { header: "" },
    ],
  },
  [TableType.FOLIOS]: {
    type: TableType.FOLIOS,
    headers: [
      { header: "Folio" },
      { header: "Cliente" },
      { header: "Correo electrónico" },
      { header: "Fecha de creación" },
      { header: "Estado" },
      { header: "" },
    ],
  },
  [TableType.FOLIOS_MINI]: {
    type: TableType.FOLIOS_MINI,
    headers: [{ header: "Folio" }, { header: "Estado" }, { header: "Creado" }],
  },
  [TableType.AGENTS]: {
    type: TableType.AGENTS,
    headers: [
      { header: "No. Empleado" },
      { header: "Nombre" },
      { header: "Correo electrónico" },
      { header: "Campaña" },
      { header: "Estado" },
    ],
    rowsPerPage: 10,
  },
};
